import numeral from 'numeral'

export function formatNumeric(value, format) {
  return numeral(value).format(format)
}
